// @core/api/endpoints/authn/create_sso_session.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateSSOSessionRequest,
  CreateSSOSessionResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Create SSO session
 * Establishes a new single sign-on session for the authenticated user. The session enables seamless authentication across multiple applications without re-login.
 */
export async function CreateSSOSession(
  data: CreateSSOSessionRequest,
  options?: RequestOptions
): Promise<CreateSSOSessionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/sso/sessions`;
  const requestOptions = options;
  return client.post<CreateSSOSessionResponse>(requestPath, data, requestOptions);
}
